import { render, staticRenderFns } from "./MiniPro.vue?vue&type=template&id=b0297592&scoped=true&"
import script from "./MiniPro.vue?vue&type=script&lang=js&"
export * from "./MiniPro.vue?vue&type=script&lang=js&"
import style0 from "./MiniPro.vue?vue&type=style&index=0&id=b0297592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0297592",
  null
  
)

export default component.exports